module.exports = __webpack_public_path__ + "static/media/sc.5477bec0.png";